import React, { Children } from "react"

import { Typography, Collapse, theme } from 'antd';
import { CaretRightOutlined } from '@ant-design/icons';
import ModalWindowCmd from "./ModalWindowCmd";
import ModalWindowPs from "./ModalWindowPs";

const contentStyle = {
    textAlign: 'center',
};




const getItems = (panelStyle) => [
    {
        key: '1',
        label: `Si vous avez "Invite de commandes"`,
        style: panelStyle,
        children: <ModalWindowCmd></ModalWindowCmd>
    },
    {
        key: '2',
        label: 'Si vous avez "Microsoft PowerShell"',
        children: <ModalWindowPs></ModalWindowPs>,
        style: panelStyle,
    },
];

function ModalWindows(params) {

    const { token } = theme.useToken();
    const panelStyle = {
        marginBottom: 24,
        background: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        border: 'none',
    };


    return (
        <>


            <Typography.Paragraph>

                Ouvrez l'explorateur de fichiers afin de retrouver le fichier listant les liens que vous venez de télécharger.

            </Typography.Paragraph>

            <Typography.Paragraph>

                Faites clic-droit : "Ouvrir dans le Terminal". Si l'option n'est pas proposée, cherchez "Afficher d'autres options" :
            </Typography.Paragraph>


            <img src={`${process.env.PUBLIC_URL}/dl_lidar_tuto_windows_1.png`} alt="Image indiquant les options proposer au click droit dans un dossier"
                style={{ width: "100%", maxWidth: 900 }} />

            <Typography.Paragraph>
                Une fois le terminal ouvert, regardez le titre de l'onglet pour voir si vous avez "Invite de commandes" ou "Microsoft PowerShell".
            </Typography.Paragraph>

            <Collapse
                bordered={false}
                expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                style={{
                    background: token.colorBgContainer,
                }}
                items={getItems(panelStyle)}
            />


        </>
    )

}

export default ModalWindows